export default __webpack_public_path__ + "static/media/2SGD.519e281e.png";